<template>
  <div class="tagtoolbarwrapper"
    :class="{'tagtoolbarwrapper_add': mode === 'add',
      'tagtoolbarwrapper_edit_pop': mode === 'edit_pop',
      'tagtoolbarwrapper_edit_list': mode === 'edit_list',
      'tagtoolbarwrapper_active': showTagToolBar,
      'darkmode': darkMode,
      }"
    role="button"
    aria-label="cancel"
    tabIndex="0"
    @click="toggleTagToolbar"
  >
   <div class="tagtoolbar"
    @click.stop
    ref="tagTooBar"
    role='presentation'
   >
    <div
      class="tagtoolbar-iconwrap"
      @click="showIconPanel"
      role='button'
      aria-label='change icon'
      tabIndex="0"
    >
      <img
        alt='icon'
        data-icon="this.iconSrc"
        :src="HttpRoot + iconSrc"
        class="tagtoolbar-icon"
        ref="tagToolBarIcon"
        v-if="iconSrc"
      />
      <img
        v-else
        alt='icon'
        data-icon="this.iconSrc"
        :src="iconSrcDefault"
        class="tagtoolbar-icon"
        ref="tagToolBarIcon"
      />
      <div class="tagtoolbar-iconmask icon-iconMask" />
    </div>
    <input
      placeholder=''
      class="tagtoolbar-name"
      type='text'
      ref="textInput"
      @keydown.esc="toggleTagToolbar"
      v-model="name"
    />
    <Btn
      class="tagtoolbar-closebtn icon-del"
      @click.native ="toggleTagToolbar"
    />
    <Btn
      v-if="mode === 'edit_pop' || mode === 'edit_list'"
      :loading="delTaging"
      @click.native ="delTagHandler"
      class="tagtoolbar-delbtn icon-trash-empty"
    />
    <Btn
      class="tagtoolbar-okbtn"
      :loading="this.addTaging || this.editTaging"
      @click.native ="addTagHandler"
      :class="{'icon-ok': !(this.addTaging || this.editTaging) }"
    />
   </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { updateContentPage } from '@/util/chrome.api.js'
import Btn from '@/components/Btn'
import { HttpRoot } from '@/config/'

export default {
  props: {
    mode: {
      type: String,
      default: 'add',
    },
    showTagToolBar: Boolean,
    toggleTagToolbar: Function,
    delTagCallback: Function,
    editTagCallback: Function,
    tag: Object,
  },
  components: {
    Btn,
  },
  data() {
    return {
      HttpRoot,
      editTaging: false,
      delTaging: false,
      addTaging: false,
      name: '',
      iconSrc: null,
      iconSrcDefault: require('@/assets/icon_default.png'),
    }
  },
  watch: {
    showTagToolBar(val) {
      if (val) {
        if (this.tag) {
          this.iconSrc = this.tag.icon
          this.name = this.tag.name
        } else {
          this.iconSrc = null
          this.name = ''
        }
        setTimeout(() => {
          this.$refs.textInput.focus()
        }, 100)
        document.body.addEventListener('keydown', this.keydownHandler, false)
      } else {
        document.body.removeEventListener('keydown', this.keydownHandler)
      }
    },
    chooseIcon(val) {
      this.iconSrc = val
    },
  },
  computed: {
    ...mapState({
      chooseIcon: state => state.icon.chooseIcon,
    }),
  },
  mounted() {
    if (this.mode === 'edit_list') {
      setTimeout(() => {
        this.$refs.textInput.focus()
      }, 100)
    }

    if ((this.mode === 'edit_pop' || this.mode === 'edit_list') && this.tag) {
      this.name = this.tag.name
      this.iconSrc = this.tag.icon
    }
  },
  methods: {
    ...mapMutations({
      hideUpgrade: 'hideUpgrade',
      toggleIconPanel: 'icon/togglePanel',
    }),
    ...mapActions({
      addTag: 'star/addTag',
      delTag: 'star/delTag',
      editTag: 'star/editTag',
    }),
    keydownHandler(e) {
      if (e.type === 'keydown' && e.keyCode === 13) {
        this.mode === 'add' ? this.addTagHandler(e) : this.editTagHandler(e)
      }
    },
    clickHandler() {
      if (this.mode === 'add') {
        this.addTag()
      } else {
        this.eidtTag()
      }
    },
    addTagHandler() {
      if (this.mode === 'edit_pop' || this.mode === 'edit_list') {
        this.editTagHandler()
        return
      }
      if (!this.name) {
        this.$toast({
          msg: this.$t('toolbar.categoryNameIvalid'),
        })
        return
      }
      this.addTaging = true
      this.addTag({
        name: this.name,
        icon: this.iconSrc,
      }).then(() => {
        this.toggleTagToolbar()
        this.addTaging = false
      }).catch(() => {
        this.addTaging = false
        this.toggleTagToolbar()
      })
    },
    editTagHandler() {
      if (!this.name) {
        this.$toast({
          msg: this.$t('toolbar.categoryNameIvalid'),
        })
        return
      }
      if (this.name === this.tag.name && (this.iconSrc === this.tag.icon)) {
        this.toggleTagToolbar(this.tag)
        return
      }
      this.editTaging = true
      this.editTag({
        tagId: this.tag._id,
        body: { name: this.name.trim(), icon: this.iconSrc },
      }).then(() => {
        this.editTaging = false
        this.toggleTagToolbar(this.tag)
        if (this.editTagCallback) {
          this.editTagCallback({
            ...this.tag,
            name: this.name.trim(),
            icon: this.iconSrc,
          })
        }
        this.$toast({
          msg: this.$t('toolbar.editsucc'),
        })
        updateContentPage({ update: true })
      })
    },
    delTagHandler() {
      this.$toast({
        msg: this.$t('toolbar.delTip'),
        isConfirm: true,
      }).then(() => {
        this.delTaging = true
        this.delTag({
          tagId: this.tag._id,
        }).then(() => {
          this.delTaging = false
          this.$toast({
            msg: this.$t('toolbar.delSucc'),
            duration: 1000,
          }).then(() => {
            if (this.delTagCallback) this.delTagCallback()
          })
          updateContentPage()
        }).catch(() => {
          this.delTaging = false
        })
      })
    },
    showIconPanel() {
      this.toggleIconPanel()
    },
  },
}
</script>

<style lang="scss" scoped>

/* newicon */
.tagtoolbarwrapper_add{
  position: absolute;
  left: 0;
  top: 152px;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-top: 270px;
  background: rgba(45, 45, 45, 0.4);
  background: rgba(255, 255, 255, 0.7);
  z-index: 100;
  transform: translate(0,-10px) scale(.95);
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease;
}

.tagtoolbar{
  height: 28px;
  padding: 5px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 15px rgba(169, 169, 169, 0.5);
  box-shadow: 0 0 26px rgba(27, 27, 27, 0.32);
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  display: flex;
}
.tagtoolbar-name{
  width: 168px;
  height: 12px;
  border: none;
  padding: 3px 4px;
  line-height: 12px;
  font-size: 12px;
  color:#353535;
  margin: 0 6px;
  flex: 1 1 auto;
  border-radius: 2px;
  overflow: hidden;
  background: #D8D8D8;
  caret-color: #B9B9B9;
  float: left;
  outline: none;
  box-shadow: inset 0 0 4px #c7c7c7
}
.tagtoolbar-iconwrap{
  width: 18px;
  height: 16px;
  padding-top: 2px;
  background: #D8D8D8;
  border-radius: 2px;
  float: left;
  line-height: 18px;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.tagtoolbar-icon{
  width: 14px;
  height: 14px;
}
.tagtoolbar-iconmask{
  position: absolute;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  background: #D8D8D8;
  opacity: 0;
  border-radius: 2px;
  text-align: center;
  z-index: 10;
 // opacity: 0.8;
  color: #858585;
  transition: opacity 0.2s ease;
  &:before{
    line-height: 100%;
  }
  &:hover{
    opacity: 0.8;
  }
}
.tagtoolbar-closebtn{
  margin-right: 5px;
}

//mode edit
//*************

.tagtoolbarwrapper_edit_pop,
.tagtoolbarwrapper_edit_list{
  .tagtoolbar {
    padding: 5px;
    height: 22px;
    width: auto;
    background: none;
    box-shadow: none;
  }
  .tagtoolbar-iconwrap{
    width: 22px;
    height: 18px;
    padding-top: 4px;
    margin-right: 5px;
    border-radius: 4px;
    background: #D5D5D5;
  }
  .tagtoolbar-icon{
    width: 14px;
    height: 14px;
  }
  .tagtoolbar-iconmask{
    &:before {
      line-height: 22px;
      font-size: 14px;
    }
  }
  .tagtoolbar-name{
    width: 117px;
    height:16px;
    margin: 0;
    padding: 3px;
    line-height: 16px;
    border-radius: 4px;
    margin-right: 5px;
  }
  .tagtoolbar-delbtn,
  .tagtoolbar-closebtn,
  .tagtoolbar-okbtn{
    width: 22px;
    height: 22px;
    line-height: 22px;
    background: #2E7FFF;
    color: #fff;
    border-radius: 4px;
    transition: background 0.2s ease;
    &:hover{
      background: #0C6AFF;
    }
  }
  .tagtoolbar-delbtn{
    // .tagToolBarOkBtn;
    background: #FB6967;
    color: #fff;
    margin-right: 5px;
    &:hover{
      background: #FD413E;
    }
  }
  .tagtoolbar-closebtn{
    background: #EBEBEB;
    color: #7B7B7B;
    &:hover{
      background: #c4c4c4;
    }
  }
}
.tagtoolbarwrapper_edit_pop {
  width: 242px;
  height: 32px;
  right: -4px;
  left: auto;
  top: 34px;
  cursor: default;
  transform: translate(0,-10px) scale(.95);
  .tagtoolbar{
    height: 32px;
  }
  .tagtoolbar-closebtn{
    background: #dddddd;
  }
}
.tagtoolbarwrapper_edit_list{
  .tagtoolbar{
    padding: 0;
  }
}
//active
//*************
.tagtoolbarwrapper_active{
  visibility: visible;
  opacity: 1;
  transform: translate(0,0) scale(1);
}

/** bigmode **/
.bigmode{
  .tagtoolbar{
    height: 22px;
    width: 256px;
    /deep/ .c_btn{
      width: 22px;
      height: 22px;
      line-height: 22px;
    }
  }
  .tagtoolbar-name{
    width: 193px;
    height: 16px;
    line-height: 16px;
    font-size: 14px;
  }
  .tagtoolbar-iconwrap{
    width: 22px;
    height: 20px;
    &:hover{
      background: rgb(197, 197, 197);
    }
  }
  .tagtoolbar-icon{
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }
  .tagtoolbar-iconmask{
    line-height: 22px;
    &:before{
      line-height: 100%;
      font-size: 14px;
    }
  }
  .tagtoolbarwrapper_edit{
    .tagtoolbar-iconwrap{
      height: 19px;
      padding-top: 3px;
      &::before{
        line-height: 22px;
      }
    }
    .tagtoolbar-delbtn{
      background: #fb6967;
    }
    .tagtoolbar-okbtn{
      background: #2e7fff;
    }
    .tagtoolbar{
      width: 206px;
    }
    .tagtoolbar-name{
      width: 118px;
    }
    .tagtoolbar-icon{
      margin-top: 0;
    }
  }
}

/** darkmode **/
.darkmode {
  .tagtoolbar{
    background: #313131;
    box-shadow: 0 0 32px rgba(25, 25, 25, 0.8);
  }
  .c_btn{
    background: #5d5d5d;
    color: #ffffff;
    &:hover{
      background: #8E8E8E;
    }
  }

  .tagtoolbar-delbtn,
  .tagtoolbar-okbtn{
    background: #2E7FFF;
    color: #fff;
    transition: background 0.2s ease;
    &:hover{
      background: #0C6AFF;
    }
  }
  .tagtoolbar-delbtn{
    // .tagToolBarOkBtn;
    background: #FB6967;
    color: #fff;
    margin-right: 5px;
    &:hover{
      background: #FD413E;
    }
  }
  .tagtoolbarwrapper_add{
    background: hsla(0, 0%, 37%, 0.7);
  }
  .tagtoolbar-name{
    color: #fff;
    background: #7d7d7d;
    box-shadow: inset 0 0 4px #515151;
  }
  .tagtoolbar-iconwrap{
    box-shadow: inset 0 0 4px #2d2d2d;
    background: #7d7d7d;
  }
}
</style>
